import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  CreateAttachment_createAttachment_attachment as CreateAttachmentAttachmentGenerated,
  CreateAttachment as CreateAttachmentGenerated,
  CreateAttachmentVariables as CreateAttachmentVariablesGenerated,
} from "core/queries/__generated__/CreateAttachment";

export interface CreateAttachment extends CreateAttachmentGenerated {}
export interface CreateAttachmentAttachment
  extends CreateAttachmentAttachmentGenerated {}
export interface CreateAttachmentVariables
  extends CreateAttachmentVariablesGenerated {}

export const createAttachment = gql`
  mutation CreateAttachment(
    $attachToNewComment: Boolean = true
    $markAllRead: Boolean = true
    $taskId: ID!
    $publicId: String!
    $format: Format!
  ) {
    createAttachment(
      targetType: task
      targetId: $taskId
      host: cloudinary
      format: $format
      resourceType: image
      attachToNewComment: $attachToNewComment
      publicId: $publicId
      markAllRead: $markAllRead
    ) {
      attachment {
        id
        url
        attachableId
        attachableType
      }
    }
  }
`;

interface UseCreateAttachmentOptions {
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: CreateAttachment) => void;
  refetchQueries?: string[];
}
export const useCreateAttachment = ({
  awaitRefetchQueries = false,
  onCompleted,
  refetchQueries = [],
}: UseCreateAttachmentOptions) =>
  useMutation<CreateAttachment, CreateAttachmentVariables>(createAttachment, {
    awaitRefetchQueries,
    onCompleted,
    refetchQueries,
  });
